<template>
  <div>
    <base-table
      ref="refTable"
      namespace="company"
      name="companies"
    >
      <template #before-navbar>
        <b-button variant="outline-primary" @click="handleCreateCompany">
          <feather-icon icon="PlusIcon"/> Create
        </b-button>
      </template>

      <template #item.id="{item}">
        <b-link :to="{name: 'company', params: {id: item.id}}">
          #{{item.id}} <b-badge variant="danger" v-if="!item.additional.is_created">Draft</b-badge>
        </b-link>
      </template>

      <template #item.favicon_url="{item}">
        <b-avatar
          style="width: 25px; height: 25px; background: transparent"
          :src="item.favicon_url"
          square
        />
      </template>

      <template #item.actions="{item}">
        <template v-if="!item.additional.is_created">
          <div class="d-flex flex-nowrap">
            <b-button class="mr-1" variant="primary" @click="handleEditCompany(item.id)">Finish</b-button>
            <b-button variant="danger" @click="handleDeleteCompany(item.id)">Delete</b-button>
          </div>

        </template>
      </template>
    </base-table>

    <base-company-modal
      :visible.sync="companyModal.visible"
      :company="companyModal.company"
      @success="handleCompanyModalSuccess"
    />
  </div>
</template>
<script>
import {
  BTooltip,
  BDropdown,
  BDropdownItem,
  BBadge,
  BButton,
  BLink,
  BAvatar,
} from 'bootstrap-vue'

import BaseCompanyModal from "@models/company/modals/base/Modal";

import {ref} from "@vue/composition-api";
import {deleteCompany, getCompany} from "@/api/company";

export default {
  name: 'CompaniesTable',
  components: {
    BTooltip,
    BDropdown,
    BDropdownItem,
    BBadge,
    BLink,
    BButton,
    BAvatar,

    BaseCompanyModal,
  },
  setup(){
    const refTable = ref()

    //Create Modal
    const companyModal = ref({visible: false, company: null})
    const handleCreateCompany = () => {

      companyModal.value.company = {
        step: 0,
        name: '',
        client_id: '',
        client_secret: '',
        oauth_data: '',
        company_id: '',
      }
      companyModal.value.visible = true
    }
    const handleCompanyModalSuccess = () => {
      companyModal.value.visible = false;
      refTable.value.fetchData()
    }
    //Edit Modal

    const handleEditCompany = (id) => {
      getCompany(id).then(response => {
        companyModal.value.company = response
        companyModal.value.visible = true
      })
    }
    const handleDeleteCompany = (id) => {
      deleteCompany(id).then(response => {
        refTable.value.fetchData()
      })
    }

    return {
      refTable,

      companyModal,
      handleCreateCompany,
      handleCompanyModalSuccess,

      handleEditCompany,
      handleDeleteCompany,
    }
  }
}
</script>
